import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import CustomPath from './views/CustomPath.vue'
import VersionNormale from './views/VersionNormale.vue'
import VersionCourte from './views/VersionCourte.vue'

Vue.use(Router)

export default new Router({
    routes: [
        {
            path: '/',
            name: 'home',
            component: Home
        },
        {
            path: '/personnalisez-votre-visite',
            name: 'customPath',
            component: CustomPath
        },
        {
            path: '/version-normale',
            name: 'VersionNormale',
            component: VersionNormale
        },
        {
            path: '/version-courte',
            name: 'VersionCourte',
            component: VersionCourte
        },
    ]
})
